<template>
    <div>
        <div class="d-flex justify-content-between p-4">
            <div>
                <span class=" proximanova fontsize14 black">Analytics Report</span>
            </div>
            <div class="d-flex justify-content-lg-center justify-content-start pt-1">
                <span
                    class="fontsize10 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 pointer"
                    :class="{'blue':selectedTab == 'video_visit'}"
                    id="posts_tab"
                    @click="changePillBtnColour('video_visit')">Video Visits</span>
                <span
                    class="fontsize10 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 pointer"
                    :class="{'blue':selectedTab == 'video_viewed'}"
                    id="posts_tab"
                    @click="changePillBtnColour('video_viewed')">Viewed %</span>
            </div>
            
            <div class="d-flex justify-content-end ">
                <span class="proximanova black60 fontsize10 pt-2">{{fromDate}} to {{toDate}}</span>     
                <div class="ml-2">
                    <a  class="btn button-create btn-color mr-2 " v-popover:foo  id="search">
                        <span class="proximanova black60 fontsize10">{{selectedStatusCode}}</span>
                        <img src="../../assets/Dropdown.svg"  class="img-fluid p-2" alt="dropdown"/>
                        <popover name="foo" class="profileStrengthpop" id="menu">
                            <div v-for="(option,index) in selectOptions" :key="index" class="p-2">                            
                                <span class="proximanova fontsize12 black80" 
                                :class="{'proximanova-semibold': option === selectedStatusCode}"
                                @click="selectedStatusCode = option">{{option}}</span>
                                <hr class="profhoriz">
                            </div>
                        </popover>
                    </a>               
                </div>
            </div>
            
        </div>
        <div v-if="selectedTab === 'video_visit'" >
            <highcharts  class="hc" :options="chartOptions"></highcharts>
        </div>
        <div v-if="selectedTab === 'video_viewed'">
            <video-viewed></video-viewed>
        </div>
    </div>
</template>
<script>
import VideoViewed from './VideoViewed.vue'
export default{
    components:{
        VideoViewed
    },
    data(){
        return{
            selectOptions: ['Last 7 Days','15 Days','30 Days','3 Months','6 Months','12 Months','Custom Range'],
            selectedStatusCode: 'Last 7 Days',
            fromDate: '25 may, 2021',
            toDate: '31 may, 2021',
            selectedTab: 'video_visit',
            chartOptions: {
                chart: {
                    type: 'areaspline'
                },               
                title: {
                    text: ''
                },
                legend: {
                    enabled:false
                },
        
                xAxis: {
                    gridLineWidth: 1,
                    visible: true,
                    categories:  ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
                    lineColor:'#007AFF',     
                },   
                yAxis: {
                    gridLineWidth: 1,
                    min: 0,
                    max:500,
                    title: {
                        text: ' '
                    },
                    plotLines: [ {
                        value: 480,
                        color: '#007AFF',
                        dashStyle: 'shortdash',
                        width: 1,
                        label: {
                            text: ''
                        }
                    }]
                },
                tooltip: {
                    enabled:false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        stacking: 'percent',
                        pointPadding: 0.2,
                        borderWidth: 0,
                        pointWidth: 15
                    }
                },  
                series: [ {
                    name: 'Jane',
                    color: '#d1e7ff',
                    lineColor:'#007AFF',   
                    lineWidth: 1,         
                    marker: {
                        fillColor: 'white',
                        lineWidth: 1,
                        lineColor: '#007AFF'
                    },
                    data: [0, 121,  112, 142,220,480,0],             
                }]
            },
        }
    },
    methods:{
        changePillBtnColour(type){
            this.selectedTab = type;
        }
    }

}
</script>
<style scoped>
.form-control{
    height: unset !important;
    font-size: 12px;
}
.form-control:focus{
   border: none;
}
.btn-color{
  border-color: #D9DCE1;
  padding: 0px 1px
}
.dropdown-position-bottom.profileStrengthpop {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: unset !important;
    transform: translate3d(-35%,0px,0px);
  }
 .vue-popover.dropdown-position-bottom.profileStrengthpop:before {
    display: none !important;
  }
 .profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1);
  opacity:0.4
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  
}
.hc{
    height: 220px;
    width: 100%;
    zoom:1;
}
.highcharts-button, .highcharts-legend, .highcharts-container > svg > text {display: none;}
</style>
